module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.sponsorAdded) ? _c('form', {
    staticClass: "field",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addSponsor()
      }
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("addSponsorView.fillSponsorInformation")))]), _vm._v(" "), _c('div', {
    staticClass: "radio-content"
  }, [_c('label', {
    attrs: {
      "for": "privateSponsor"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsor.sponsorType),
      expression: "sponsor.sponsorType"
    }],
    attrs: {
      "type": "radio",
      "name": "sponsorType",
      "id": "privateSponsor",
      "checked": "",
      "value": "Private"
    },
    domProps: {
      "checked": _vm._q(_vm.sponsor.sponsorType, "Private")
    },
    on: {
      "__c": function($event) {
        _vm.sponsor.sponsorType = "Private"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label-text"
  }, [_vm._v(_vm._s(_vm.$t("addSponsorView.private")))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark icon-checkmark"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "companySponsor"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsor.sponsorType),
      expression: "sponsor.sponsorType"
    }],
    attrs: {
      "type": "radio",
      "name": "sponsorType",
      "id": "companySponsor",
      "value": "Company"
    },
    domProps: {
      "checked": _vm._q(_vm.sponsor.sponsorType, "Company")
    },
    on: {
      "__c": function($event) {
        _vm.sponsor.sponsorType = "Company"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label-text"
  }, [_vm._v(_vm._s(_vm.$t("addSponsorView.company")))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark icon-checkmark"
  })])]), _vm._v(" "), (_vm.sponsor.sponsorType === 'Company') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsor.companyName),
      expression: "sponsor.companyName"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('addSponsorView.companyName')
    },
    domProps: {
      "value": (_vm.sponsor.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sponsor.companyName = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsor.firstname),
      expression: "sponsor.firstname"
    }],
    attrs: {
      "required": "",
      "type": "text",
      "placeholder": _vm.$t('addSponsorView.firstname')
    },
    domProps: {
      "value": (_vm.sponsor.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sponsor.firstname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsor.lastname),
      expression: "sponsor.lastname"
    }],
    attrs: {
      "required": "",
      "type": "text",
      "placeholder": _vm.$t('addSponsorView.lastname')
    },
    domProps: {
      "value": (_vm.sponsor.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sponsor.lastname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsor.email),
      expression: "sponsor.email"
    }],
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('addSponsorView.email')
    },
    domProps: {
      "value": (_vm.sponsor.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sponsor.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsor.streetAddress),
      expression: "sponsor.streetAddress"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('addSponsorView.streetAddress')
    },
    domProps: {
      "value": (_vm.sponsor.streetAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sponsor.streetAddress = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsor.zipCode),
      expression: "sponsor.zipCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('addSponsorView.zipCode')
    },
    domProps: {
      "value": (_vm.sponsor.zipCode)
    },
    on: {
      "change": function($event) {
        _vm.zipCodeChanged()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sponsor.zipCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsor.city),
      expression: "sponsor.city"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('addSponsorView.city')
    },
    domProps: {
      "value": (_vm.sponsor.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sponsor.city = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.sponsor.sponsorType == 'Company') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsor.info),
      expression: "sponsor.info"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('addSponsorView.info')
    },
    domProps: {
      "value": (_vm.sponsor.info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sponsor.info = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "radio-content"
  }, [_c('label', {
    attrs: {
      "for": "oneTimePayment"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsor.paymentMethod),
      expression: "sponsor.paymentMethod"
    }],
    attrs: {
      "type": "radio",
      "name": "paymentType",
      "id": "oneTimePayment",
      "checked": "",
      "value": "Manual"
    },
    domProps: {
      "checked": _vm._q(_vm.sponsor.paymentMethod, "Manual")
    },
    on: {
      "__c": function($event) {
        _vm.sponsor.paymentMethod = "Manual"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label-text"
  }, [_vm._v(_vm._s(_vm.$t("addSponsorView.oneTimePayment")))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark icon-checkmark"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "paymentPerRepeat"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsor.paymentMethod),
      expression: "sponsor.paymentMethod"
    }],
    attrs: {
      "type": "radio",
      "name": "paymentType",
      "id": "paymentPerRepeat",
      "value": "PerRepeat"
    },
    domProps: {
      "checked": _vm._q(_vm.sponsor.paymentMethod, "PerRepeat")
    },
    on: {
      "change": _vm.perRepeatPaymentSelected,
      "__c": function($event) {
        _vm.sponsor.paymentMethod = "PerRepeat"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label-text"
  }, [_vm._v(_vm._s(_vm.$t("addSponsorView.paymentPerRepeat")))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark icon-checkmark"
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsor.payment),
      expression: "sponsor.payment"
    }],
    attrs: {
      "required": "",
      "type": "number",
      "step": "any",
      "placeholder": _vm.$t('addSponsorView.paymentAmount', [_vm.minPayment])
    },
    domProps: {
      "value": (_vm.sponsor.payment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sponsor.payment = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "radio-content"
  }, [_c('label', {
    attrs: {
      "for": "paymentMethodMail"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsor.preferredBillingMethod),
      expression: "sponsor.preferredBillingMethod"
    }],
    attrs: {
      "id": "paymentMethodMail",
      "type": "radio",
      "name": "payment-method",
      "value": "Mail"
    },
    domProps: {
      "checked": _vm._q(_vm.sponsor.preferredBillingMethod, "Mail")
    },
    on: {
      "change": function($event) {
        _vm.billingMethodChanged()
      },
      "__c": function($event) {
        _vm.sponsor.preferredBillingMethod = "Mail"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label-text"
  }, [_vm._v(_vm._s(_vm.$t("addSponsorView.paymentMethodMail")))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark icon-checkmark"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "paymentMethodEmail"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsor.preferredBillingMethod),
      expression: "sponsor.preferredBillingMethod"
    }],
    attrs: {
      "id": "paymentMethodEmail",
      "type": "radio",
      "name": "payment-method",
      "value": "Email"
    },
    domProps: {
      "checked": _vm._q(_vm.sponsor.preferredBillingMethod, "Email")
    },
    on: {
      "change": function($event) {
        _vm.billingMethodChanged()
      },
      "__c": function($event) {
        _vm.sponsor.preferredBillingMethod = "Email"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label-text"
  }, [_vm._v(_vm._s(_vm.$t("addSponsorView.paymentMethodEmail")))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark icon-checkmark"
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "paymentMethodEInvoice"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsor.preferredBillingMethod),
      expression: "sponsor.preferredBillingMethod"
    }],
    attrs: {
      "id": "paymentMethodEInvoice",
      "type": "radio",
      "name": "payment-method",
      "value": "EInvoice"
    },
    domProps: {
      "checked": _vm._q(_vm.sponsor.preferredBillingMethod, "EInvoice")
    },
    on: {
      "change": function($event) {
        _vm.billingMethodChanged()
      },
      "__c": function($event) {
        _vm.sponsor.preferredBillingMethod = "EInvoice"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label-text"
  }, [_vm._v(_vm._s(_vm.$t("addSponsorView.paymentMethodEInvoice")))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark icon-checkmark"
  })])]), _vm._v(" "), (_vm.sponsor.preferredBillingMethod == 'EInvoice') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t("addSponsorView.bank")))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px",
      "margin-bottom": "20px",
      "text-align": "center"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsor.bankId),
      expression: "sponsor.bankId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sponsor.bankId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.banks), function(bank) {
    return _c('option', {
      key: bank.bankId,
      domProps: {
        "value": bank.bankId
      }
    }, [_vm._v(_vm._s(bank.name) + " (" + _vm._s(bank.bic) + ")")])
  }))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t("addSponsorView.eInvoicePaymentAddress")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsor.eInvoicePaymentAddress),
      expression: "sponsor.eInvoicePaymentAddress"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sponsor.eInvoicePaymentAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sponsor.eInvoicePaymentAddress = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button button-green",
    attrs: {
      "type": "submit",
      "disabled": !_vm.isValidatedForSave
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t("addSponsorView.saveSponsor")) + "\r\n        ")])]) : _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t("addSponsorView.sponsorAdded")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23302230","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/views/AddSponsorView.vue
// module id = 113
// module chunks = 0